import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      // video={
      //   'https://assets.fubo.tv/marketing/lp/videos/compressed/ManUnited2022_1280x720_LP_5s_v2.mp4'
      // }
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_United_Hero_Desktop.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_United_Hero_Mobile.jpg"
      title="Watch Manchester United soccer live"
      subtitle={subtitleText.epl}
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      team="Manchester United"
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
      // hasScheduleBanner={true}
    />
  )
}
